import React from 'react'
import './App.css'

import ProfileLogin from '../containers/ProfileLogin'
import Smm from '../containers/Smm'

class App extends React.Component {

  render(){
   return (
		 <div>
			 <Smm location={this.props.location}/>
		 </div>
   )
  }
}

export default App


// WEBPACK FOOTER //
// /var/www/build-health-2/src/components/App.js